<template>
	<div class="login">
		<img src="/static/img/bj1.png" alt="" class="login-bg">
		<div class="login-all">
			<div class="login-all-left">
				<div class="logo">
					<img src="/static/img/logo.png" alt="" />
				</div>
			</div>
			<div class="login-all-right">
				<div class="register">
					<p>您是否完成注册，请先前往<span>注册</span></p>
				</div>
				<h1>登录•LOGIN</h1>
			    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true">
				    <el-tab-pane label="用户管理" name="first">
				    	<div class="Email">
				    		<p>邮箱:</p>
				    		<input type="text" />
				    		<p style="margin-top: 24px">密码:</p>
				    		<input type="text" />
				    	</div>
				    </el-tab-pane>
				    <el-tab-pane label="配置管理" name="second">
				    	<div class="Email">
				    		<p>邮箱:</p>
				    		<input type="text" />
				    		<p style="margin-top: 24px;">密码:</p>
				    		<input type="text" />
				    	</div>
				    </el-tab-pane>
				  </el-tabs>
				  <div class="enroll">
				  	<p>登录</p>
				  </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"Enter",
		data(){
			return{
				activeName: 'second'
			}
		},
		methods: {
	      	handleClick(tab, event) {
	        console.log(tab, event);
	      	}
	    }
	}
</script>

<style>
	/*.box-header{
		display: none;
	}
	.footer-area{
		display: none;
	}*/
	.login{
		width: 100%;
		height: 1025px;
		position: relative;
		background:url("/static/img/bj2.png") no-repeat;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.login-bg{
		position: absolute;
		right: 0px;
		bottom: 0px;
	}
	.login-all{
		width: 1120px;
		height: 810px;
		border:76px solid rgba(255,255,255,0.5);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.login-all-left{
		width: 342px;
		height: 810px;
		background-color: #2d2b6a;
		display: flex;
		justify-content: center;
	}
	.login-all-right{
		width: 854px;
		height: 810px;
	}
	.login-all-left .logo{
		margin-top: 40px;
	}
	.login-all-right .register{
		height: 45px;
		overflow: hidden;
		position: relative;
	}
	.login-all-right .register p{
		position: absolute;
		right: 30px;
		bottom: 0px;
		color: #9392a2;
	}
	.login-all-right .register span{
		color:#7ba2ff;
	}
	.login-all-right h1{
		font-size: 36px;
		margin-top: 98px;
		text-align: center;
		margin-bottom: 65px;
	}
	.el-tabs__item{
		font-size: 24px;
		margin: auto;
	}
	.el-tabs__nav{
		width:500px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.Email{
		margin-top: 42px;
	}
	.Email p{
		font-size: 20px;
		margin-left: 150px;
	}
	.Email input{
		margin-left: 150px;
		border: none;
		outline: none;
		border: 1px solid #ccc;
		width: 515px;
		padding-left: 15px;
		border-radius: 4px;
	}
	.enroll{
		width: 515px;
		height: 56px;
		background-color: #6a96ff;
		margin-top: 50px;
		margin-left: 150px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.enroll p{
		font-size: 22px;
	}
</style>


// WEBPACK FOOTER //
// src/views/Enter.vue